<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packManufacturedDate')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packManufacturedDateStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    mfgdate
                      ? mfgdate
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packImportedDate')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packImportedDateStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    impDate
                      ? impDate
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packExpirationDate')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packExpirationDateStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    pckexpDate
                      ? pckexpDate
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.expiredSoonFlag')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.expiredSoonFlagState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{$t('drug.expiredSoonFlag')}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packTotalVolumeLeft')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packTotalVolumeLeftState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packTotalVolLeft
                      ? getdrug.packTotalVolLeft
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >stock Warning Flag
                  <v-icon>mdi-information-outline</v-icon></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2">
                  {{ "Out of stock Warning" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >Stock Treshold<v-icon
                    >mdi-information-outline</v-icon
                  ></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2">
                  {{ "Out of Stock Treshold" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >Pack Id
                  <v-icon>mdi-information-outline</v-icon></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2">
                  {{ getdrug.packId ? getdrug.packId : "Not Specified" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>
                  Warning Flag<v-icon
                    >mdi-information-outline</v-icon
                  ></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2">
                  {{ "Out of Stock Critical Warning Flag" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "PackExpiration",
   mounted(){
    this.mfgdate=this.dateFormat(this.getdrug.packManufacturedDate)
    this.impDate=this.dateFormat(this.getdrug.packImportedDate)
    this.pckexpDate=this.dateFormat(this.getdrug.PackExpirationDate)
  },
  computed: {
    ...mapGetters(["getdrug"]),
  },
    data(){
    return{
      mfgdate:"",
      impDate:"",
      pckexpDate:""
    }
  },
  props:["dateFormat"]
};
</script>